import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import SocialLinksTable from "./SocialLinksTable";
function SocialLinks() {
  return (
    <>
      <Grid size={12}>
        <SocialLinksTable />
      </Grid>
    </>
  );
}

export default SocialLinks;
